import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Row,
  Col,
  Button,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";
import Header from "../../components/Layout/Header";
import Sidebar from "../../components/Layout/Sidebar";
import Main from "../../components/Layout/Main";
import SweetAlertWrapper from "../../components/Layout/sweetAlert";
import { download_retailer_letter } from "../../api/otogas";
import DistributorContext from "../../context/distributor/distributorContext";
import AddRetailerModal from "./addRetailer";
import AddRetailerOutletModal from "./addRetailerOutlet";

const ListRetailers = () => {
  const navigate = useNavigate();
  const distributorContext = useContext(DistributorContext);
  const {
    listRetailers,
    retailers,
    addRetailer,
    addRetailerOutlet,
    notification,
  } = distributorContext;

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ text: "", type: "" });
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showOutletModal, setShowOutletModal] = useState(false);
  const [selectedRetailerCode, setSelectedRetailerCode] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    listRetailers(1, 10, search);
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      listRetailers(1, 10, search);
    }, 500); // debounce

    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    if (notification) {
      setAlertMessage({
        text: notification.text,
        type: notification.type,
      });
      setShowAlert(true);
    }
  }, [notification]);

  const handleConfirm = () => {
    setShowAlert(false);
  };

  const handle_downloads = async (func) => {
    setLoadingSummary(true);
    try {
      const res = await func();
      if (res === "File not found") {
        setAlertMessage({ text: "No transactions found", type: "info" });
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error downloading the file:", error);
      setAlertMessage({
        text: "An error occurred while downloading the file",
        type: "danger",
      });
      setShowAlert(true);
    } finally {
      setLoadingSummary(false);
    }
  };

  const handleAddRetailer = async (data) => {
    try {
      if (addRetailer) {
        await addRetailer(data);
        listRetailers(1, 10);
      } else {
        console.warn("addRetailer method not found");
      }
    } catch (err) {
      console.error("Error adding retailer:", err);
    } finally {
      setShowAddModal(false);
      setShowAlert(true);
    }
  };

  const handleAddOutlet = async (outletData) => {
    try {
      await addRetailerOutlet(outletData);
      setAlertMessage({ text: "Outlet added successfully", type: "success" });
    } catch (err) {
      setAlertMessage({ text: "Failed to add outlet", type: "danger" });
    } finally {
      setShowAlert(true);
    }
  };

  return (
    <div>
      <Header />
      <Sidebar page="Retailers" />
      <Main>
        <SweetAlertWrapper
          show={showAlert}
          title="Notification"
          message={alertMessage.text}
          onConfirm={handleConfirm}
          confirmBtnText="OK"
          type={alertMessage.type || "info"}
        />

        <Row className="mb-3">
          <Col>
            <Button variant="success" onClick={() => setShowAddModal(true)}>
              + Add Retailer
            </Button>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <input
              type="text"
              className="form-control"
              placeholder="Search Retailers"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Retailer ID</th>
              <th>Business Name</th>
              <th>Retailer Name</th>
              <th>Retailer Email</th>
              <th>Retailer Phone</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {retailers && retailers.length > 0 ? (
              retailers.map((retailer) => (
                <tr key={retailer.retailerCode}>
                  <td>{retailer.retailerCode}</td>
                  <td>{retailer.bussinessName}</td>
                  <td>{retailer.bussinessOwnerName}</td>
                  <td>{retailer.email}</td>
                  <td>{retailer.phoneNumber}</td>
                  <td>
                    <DropdownButton
                      as={ButtonGroup}
                      title="Actions"
                      id="bg-nested-dropdown"
                      variant="secondary"
                    >
                      <Dropdown.Item
                        onClick={() =>
                          handle_downloads(() =>
                            download_retailer_letter(retailer.retailerCode)
                          )
                        }
                      >
                        Download Letter
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => {
                          setSelectedRetailerCode(retailer.retailerCode);
                          setShowOutletModal(true);
                        }}
                      >
                        Add Retailer Outlets
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handle_downloads(() =>
                            download_retailer_letter(retailer.retailerCode)
                          )
                        }
                      >
                        View Retailer Outlets
                      </Dropdown.Item>
                    </DropdownButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No retailers found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <AddRetailerModal
          show={showAddModal}
          handleClose={() => setShowAddModal(false)}
          onSubmitData={handleAddRetailer}
        />

        <AddRetailerOutletModal
          show={showOutletModal}
          handleClose={() => setShowOutletModal(false)}
          onSubmitData={handleAddOutlet}
          retailerCode={selectedRetailerCode}
        />
      </Main>
    </div>
  );
};

export default ListRetailers;
